import { lazy, Suspense, type ComponentType, type ReactNode } from "react";
import { createBrowserRouter } from "react-router";
import { Spinner } from "@/shared/ui/Spinner";
import { Layout } from "./Layout";
import { NotFoundPage } from "./NotFoundPage";
import { RequireAdmin } from "./RequireAdmin";

// Each tab is its own chunk.
function page(load: () => Promise<{ default: ComponentType }>): ReactNode {
  const Page = lazy(load);
  return <Suspense fallback={<Spinner />}><Page /></Suspense>;
}

// Every route but sign-in is admin-only (RequireAdmin around the Layout).
export const router = createBrowserRouter([
  { path: "sign-in", element: page(() => import("@/features/auth/SignInPage")) },
  {
    element: <RequireAdmin><Layout /></RequireAdmin>,
    children: [
      { index: true, element: page(() => import("@/features/dashboard/DashboardPage")) },
      { path: "dungeons", element: page(() => import("@/features/dungeons/DungeonsPage")) },
      { path: "validation", element: page(() => import("@/features/validation/ValidationPage")) },
      { path: "heroes", element: page(() => import("@/features/characters/HeroesPage")) },
      { path: "bestiary", element: page(() => import("@/features/characters/BestiaryPage")) },
      { path: "weapons", element: page(() => import("@/features/weapons/WeaponsPage")) },
      { path: "tuning", element: page(() => import("@/features/tuning/TuningPage")) },
      { path: "live", element: page(() => import("@/features/live/LivePage")) },
      { path: "game-settings", element: page(() => import("@/features/gameSettings/GameSettingsPage")) },
      { path: "settings", element: page(() => import("@/features/settings/SettingsPage")) },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
